module.exports = __webpack_public_path__ + "static/media/gum_card2.df31dfa5.jpg";